import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d4d88fea"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "mt-n3 mb-1 text-dark" }, "Crie sua Campanha")
], -1));
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, " Causa ", -1));
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, " Título da Campanha ", -1));
const _hoisted_8 = { class: "col-12" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, [
    /*#__PURE__*/ _createTextVNode(" Link "),
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fa fa-info-circle",
        title: "O link que será usado para localizar sua campanha. Informe apenas letras, números ou hífen. Escolha com sabedoria: Quanto menor, mais fácil será dos doadores decorarem."
    })
], -1));
const _hoisted_10 = { class: "input-group" };
const _hoisted_11 = { class: "input-group-addon" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", null, "Planeje sua Campanha", -1));
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "col-sm-12 mb-3" };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = { class: "col-sm-12" };
const _hoisted_17 = { class: "" };
const _hoisted_18 = { class: "input-group" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-addon" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-money-bill-wave" })
], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AutocompleteGenerico = _resolveComponent("AutocompleteGenerico");
    const _directive_input_format = _resolveDirective("input-format");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_AutocompleteGenerico, {
                    modelValue: _ctx.campanha.causa_id,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((_ctx.campanha.causa_id) = $event)),
                        _cache[1] || (_cache[1] = ($event) => (_ctx.onChangeCausa()))
                    ],
                    url: "/restrito/causas/autocomplete",
                    "text-alias": "nome",
                    required: ""
                }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.campanha.titulo) = $event)),
                    required: "",
                    maxlength: "70",
                    onChange: _cache[3] || (_cache[3] = ($event) => (_ctx.changeTitulo())),
                    placeholder: "Título da Campanha - máximo 70 caracteres"
                }, null, 544), [
                    [_vModelText, _ctx.campanha.titulo]
                ])
            ]),
            _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.campanha.dominio_encurtador) + "/ ", 1),
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        required: "",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.campanha.slug) = $event)),
                        maxlength: "70",
                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.blurSlug())),
                        placeholder: "Ex.: fernando-campanha-do-bem"
                    }, null, 544), [
                        [_vModelText, _ctx.campanha.slug]
                    ])
                ])
            ])
        ]),
        _createElementVNode("fieldset", null, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.campanha.is_recorrente) = $event)),
                            onChange: _cache[7] || (_cache[7] = ($event) => (_ctx.changeIsRecorrente()))
                        }, null, 544), [
                            [_vModelCheckbox, _ctx.campanha.is_recorrente]
                        ]),
                        _createTextVNode(" Permitir contribuições recorrentes mensais ")
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, " Meta de Arrecadação " + _toDisplayString(_ctx.campanha.is_recorrente ? 'Mensal' : ''), 1),
                    _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.campanha.valor_objetivo) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.campanha.valor_objetivo],
                            [_directive_input_format, 'moeda']
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
